import CryptoJS from "crypto-js";

const SECRET_KEY = "1234567890abcdef1234567890abcdef";

const getAuthHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return { Authorization: `Bearer ${authToken}` };
};

const decryptFunction = (ciphertext) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (e) {
    console.error("Notification decrypt failed:", e);
    return [];
  }
};

/**
 * Fetch notifications for a user.
 * Returns an array of notification objects.
 */
export async function fetchNotificationsAPI(userId) {
  const baseUrl = process.env.REACT_APP_NOTIFICATIONS_API;

  if (!baseUrl || !userId) return [];

  const url = baseUrl.includes("?")
    ? `${baseUrl}&userId=${userId}`
    : `${baseUrl}?userId=${userId}`;

  try {
    const res = await fetch(url, { headers: getAuthHeaders() });
    if (!res.ok) throw new Error(`Status ${res.status}`);
    const encrypted = await res.text();
    return decryptFunction(encrypted);
  } catch (err) {
    console.error("fetchNotificationsAPI error:", err);
    return [];
  }
}

/**
 * Mark all notifications as read for a user.
 * @returns {Promise<boolean>} - Returns true on success, false on failure
 */
export async function markNotificationsReadAPI(userId) {
  const baseUrl = process.env.REACT_APP_NOTIFICATIONS_API;
  if (!baseUrl || !userId) {
    console.warn("markNotificationsReadAPI: Missing baseUrl or userId");
    return false;
  }

  const url = baseUrl.includes("?")
    ? `${baseUrl}&userId=${userId}`
    : `${baseUrl}?userId=${userId}`;

  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: getAuthHeaders(),
    });

    if (!res.ok) {
      console.error(
        `markNotificationsReadAPI failed with status ${res.status}`,
      );
      return false;
    }

    console.log("markNotificationsReadAPI: Successfully marked all as read");
    return true;
  } catch (err) {
    console.error("markNotificationsReadAPI error:", err);
    return false;
  }
}

export async function updateNotificationStatusAPI(
  notificationId,
  userId,
  isSeen = true,
) {
  const baseUrl = process.env.REACT_APP_NOTIFICATIONS_API;

  const url = baseUrl.includes("?")
    ? `${baseUrl}&notificationId=${notificationId}&userId=${userId}`
    : `${baseUrl}?notificationId=${notificationId}&userId=${userId}`;

  try {
    await fetch(url, {
      method: "PATCH",
      headers: {
        ...getAuthHeaders(),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ isSeen }),
    });
  } catch (err) {
    console.error("updateNotificationStatusAPI error:", err);
  }
}
